import axios from 'axios'

import nfsyn from '@utils/nf-webaudio/nf-webaudio'
export interface UtilsType {
  decibelsToFactor: (db: number) => number
  parseProperty: (
    parseFunction: (value: string) => any,
    xml: Element,
    selector: string,
    object: any,
    property?: string
  ) => void
  parseStringProperty: (xml: Element, selector: string, object: any, property?: string) => void
  loadAudioBuffer: (
    url: string,
    audioContext: AudioContext | OfflineAudioContext,
    callback: (buffer: any) => void,
    opt_errorCallback: (error: string) => void
  ) => void
  parseNote: (s: string) => number
}

// Utility routines.
const utils: UtilsType = {
  parseProperty: (parseFunction, xml, selector, object, property) => {
    const elements = xml.querySelectorAll(`:scope > ${selector}`)
    if (!elements) return
    ;[...elements].forEach((element: Element) => {
      if (!element.textContent) return
      object[property || selector] = parseFunction(element.textContent)
    })
  },
  parseStringProperty: (xml, selector, object, property) => {
    const elements = xml.getElementsByTagName(selector)
    if (!elements) return
    ;[...elements].forEach((element: Element) => {
      if (!element.textContent) return
      object[property || selector] = element.textContent
    })
  },
  // Noteflight pitch encoding parse function.
  parseNote: (s: string) => {
    const index = 'CDEFGAB'.indexOf(s.charAt(0))
    let pitch = [0, 2, 4, 5, 7, 9, 11][index]
    s = s.substring(1)
    if (s.charAt(0) == '#') {
      pitch++
      s = s.substring(1)
    } else if (s.charAt(0) == 'b') {
      pitch--
      s = s.substring(1)
    }
    const octave = Number(s)
    pitch += octave * 12
    return pitch
  },
  // Convert from dB to a multiplicative gain factor.
  decibelsToFactor: (dB: number): number => Math.exp((dB * Math.LN10) / nfsyn.DECIBELS_PER_DECADE),
  // Loads a sound from a URL into an AudioBuffer, then calls callback(buffer). If something goes wrong, and
  // opt_errorCallback (optional) is specified, calls opt_errorCallback(errorMessage). If opt_errorCallback
  // is not specified, then an error will result in an alert box.
  loadAudioBuffer: (
    url: string,
    audioContext: AudioContext | OfflineAudioContext,
    callback,
    opt_errorCallback
  ) => {
    // We use a raw XHR here to load the audio file, because jQuery can't handle arraybuffer arguments.
    axios
      .get(url, { responseType: 'arraybuffer' })
      .then(({ data }) => {
        audioContext.decodeAudioData(data, callback, function () {
          opt_errorCallback('EEOR: Decoding Audio File Data ' + url)
        })
      })
      .catch(() => {
        console.error(`ERROR: Fetching Audio File ${url}`)
      })
  },
}

export default utils
